// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const NODE_BASE_URL = "https://tlc-loyalty-program-dev-pro.herokuapp.com/"; //SIT
export const NODE_BASE_URL = "https://tlc-loyalty-program-uat.herokuapp.com/"; //UAT
// export const NODE_BASE_URL = "https://tlc-loyalty-program-prod.herokuapp.com/"; //PROD

export const environment = {
  production: true,

  /******************** Start PROD Environment   ************************/
  //  base_url: 'https://customerapp.tlcgroup-platform.com/api',
  // webAppBaseUrl: "https://webapp.tlcgroup-platform.com/api",

  /******************** End PROD Environment   ************************/


  /******************** Start PUAT Environment   ************************/
  base_url: "https://customerapp-uat.tlcgroup-test-platform.com/api",
  webAppBaseUrl: "https://webapp-uat.tlcgroup-test-platform.com/api",
  /******************** End PUAT Environment   ************************/


  /******************** Start SIT Environment   ************************/
  // base_url: "https://customerapp-dev-int.tlcgroup-test-platform.com/api",
  /******************** End SIT Environment   ************************/


  /******************** Start AEM Environment   ************************/
  // s3_base_url: "https://tlcdigi-her.s3.amazonaws.com/", // PROD
  s3_base_url :"https://tlcdigitechstage.s3.ap-south-1.amazonaws.com/", //UAT
  // s3_base_url: "https://tlcdigitech.s3.ap-south-1.amazonaws.com/", //SIT
  
  s3_translation_url:"content/dam/tlc/",
  aem_base_url: NODE_BASE_URL,
  aem_search_url: NODE_BASE_URL + "api/tlc/identifiersExporter",
  aemMembershipImageUrl: NODE_BASE_URL + "api/tlc/walletcardExporter",
  googleWalletUrl : NODE_BASE_URL + "generatePassForGoogleWallet/",
  appleWalletUrl : NODE_BASE_URL + "api/pkpass/",
  /******************** End AEM Environment   ************************/

  /******************** START Lead Form SECTION *****************************/
  // organizationID: '00D0o000001B5aH', // PROD
  organizationID: '00D1y0000008lSY', // UAT
  // organizationID: '00DBg000000Etr3', // SIT
  
  /***************** Table Reservation Base URL ****************************************/
  webDirectory: "",
  // tableReservation: "https://www.tlcdigitech.com/table-reservations?data=", // PROD
  tableReservation: "https://tblresvuat.tlcdigitech.com?data=", // UAT
  /******************** End Table Reservation End Base URL *****************************/

  /***************** Delivery Solution Base URL ****************************************/
    // deliverySolution: "https://delivery.tlcdigitech.com?data=", // PROD 
    // deliverySolution: "https://betadelivery.tlcdigitech.com?data=", // PROD Beta
    deliverySolution: "https://stagedelivery.tlcdigitech.com?data=", // UAT
  /******************** End Delivery Solution End Base URL *****************************/
  

  /******************** Website Captcha SECTION *****************************/
  RECAPTCHA_SITE_KEY: '6Leocg4qAAAAAGleIqd5maVC9dKqCef0mPhAqQqZ',
  RECAPTCHA_SECRET_KEY: '6Leocg4qAAAAAGU4IMNOAxQgJnh6BmOvrPABewsS',
  /******************** End Website Captcha SECTION *****************************/


  /****** Apple Wallet URL  ****/
  // apple_wallet : "https://sfdc.tlcgroup-platform.com/api/applewallet/",  //PROD
  apple_wallet : "https://pos-uat.tlcgroup-test-platform.com/api/applewallet/", //UAT

  /****** google Wallet URL  ****/
  // google_wallet : "https://tlc-loyalty-program-prod.herokuapp.com/generatePassForGoogleWallet/", //PROD
  google_wallet : "https://tlc-loyalty-program-uat.herokuapp.com/generatePassForGoogleWallet/",  //UAT

  /******************** Start Branding Section  ************************/
  brand: 'leela hotels new',
  brandsName: 'Leela Hotels',
  programName: "Connoisseur Club New",
  currentBrand: 'Connoisseur Club New', //For multi-language
  // brandURL: '', //For multi-language
  careURL: '', //For multi-language
  // websiteURL: '', //For multi-language
  identifierUrl: '/content/tlc/', //For multi-language
  currentCountry: 'in', //For multi-language
  countryAEM: 'IN',  // FOR AEM API FOR WELCOME SCREEN SLIDER IMAGE
  /*Headers*/
  headers: {
    client_id: "MAHJSHJJSJHJSFSF",
    client_secret: "KDFKJDKJDKFJKJKDF",
    appid: "com.tlcgroup.ccn_c",
    program_id: "TLC_LLA_CCNW",
    subprogramid: "TLC_LLA_CCNW_IND",
    country: "IN", // FIXME: should be part of geo coder
    nationality: "Indian",
    language: "en",
    apkversion: "1" // we need api version confirmation from backend before every release
  },
  languages: [{
    name: "English",
    code: "en",
    id: "English",
    jsonFileURL: "location of en specific i18n file"
  }],
  program: "Connoisseur Club New", // Added for welcome-screen aem api
  subprogram: "Connoisseur Club New India", // Added for welcome-screen aem api
  brandName: "Leela Hotels:",
  bundle_Id: "com.tlcgroup.customer.connisseurclub",
  iosApp_Id: "",
  appDBName: {
    name: "TLC_DB",
    order_Exec: ["sqlite", "indexeddb", "websql"],
  },
  appVersion: '1.0.0',
  uiVersion: 1,// We use this key to change version 1 code (CM,DP.GC) and version 2 code SR, 3 for PC
  /******************** End Branding Section  ************************/

  GOOGLE_MAPS_API_KEY: "AIzaSyCpXb01KpCbLPdHsSvggQjvRqO4G2ZUUXo",


  /******************** START GST SECTION *****************************/
  taxType: 'GST',
  taxPercentKey: 'TAX',
  taxRegex: /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/,
  taxPlaceHolder: '22AAAAA0000A1Z5',

  /******************** END GST SECTION *****************************/
    saftyNetKey: 'AIzaSyBimn-KaUDGvVTL81OYDfJAfNKpI4TPmKw',

  /******************** START SMS SECTION *****************************/
    smsSenderId: "CLMARR",
  /******************** END SMS SECTION *****************************/

  /*************************** QR scanner URL *************************************/
    qrScanner: "https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=",
  /*************************** END QR scanner URL *************************************/

  /******************************* CCAvenue URLs SIT-UAT ***********************************/
    CCAvenueCallbackBaseUrl: "tlc.",
    CCAvenueCallbackUrlEndSuccess: ".success.json",
    CCAvenueCallbackUrlEndFailure: ".failure.json",

    CCAenvironments: [
      "dev",
      "uat",
      "sit"
    ],

  /******************************* CCAvenue URLs Prod ***********************************/
  // CCAvenueCallbackBaseUrl: "https://www.clubmarriott.in/content/tlc-website/language-masters/en/marriott/club-marriott/club-marriott-india/home.tlc.",

  //  CCAvenueCallbackBaseUrl: "tlc.",
  //  CCAvenueCallbackUrlEndSuccess: ".success.json",
  //  CCAvenueCallbackUrlEndFailure: ".failure.json",
  //  CCAenvironments: [
  //    "dev",
  //    "uat",
  //    "sit",
  //    "prod"
  //  ],
  /******************************* END: CCAvenue URLs ***********************************/


  /******************** START GET IP ADDRESS API URL SECTION *****************************/
    getIPinfo: "https://pro.ip-api.com/json/?key=O80jLviQeItbkWK",
  /******************** END GET IP ADDRESS API URL SECTION *****************************/

  /******************** START FCM Sender ID SECTION *****************************/
    FCMSenderId: ''
  /******************** END FCM Sender ID SECTION *****************************/

};

export const firebaseConfig = {
  apiKey: "AIzaSyBVovk1gGKwLBYkDmiYsyLkxD_1YzmLoZ0",
  authDomain: "connoisseurclubweb.firebaseapp.com",
  projectId: "connoisseurclubweb",
  storageBucket: "connoisseurclubweb.appspot.com",
  messagingSenderId: "663120983601",
  appId: "1:663120983601:web:058508f645a5afec0c0710"
};


/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.